<template>
  <div class="pa-2 legend-overview">
    <table>
      <colgroup>
        <col style="width:30px;max-width: 30px;">
        <col style="width:21px;max-width: 21px;">
        <col>
      </colgroup>
      <tbody>
      <tr>
        <td rowspan="4">
          <div
            style="margin-top: 40px;margin-left: 5px;font-weight:bold;-moz-transform: rotate(270deg);-ms-transform: rotate(270deg);-o-transform: rotate(270deg);-webkit-transform: rotate(270deg);transform: rotate(270deg);">
            {{ $t('LIST_DIVERSE.LEGEND') }}
          </div>
        </td>
        <td class="pa-0">
          <div class="legend-color-yellow"></div>
        </td>
        <td><span>{{ $t('LIST_DIVERSE.FORMS_IN_PROGRESS') }}</span></td>
      </tr>
      <tr>
        <td class="pa-0">
          <div class="legend-color-green"></div>
        </td>
        <td><span>{{ $t('LIST_DIVERSE.FORMS_READY_TO_REPORT') }}</span></td>
      </tr>
      <tr>
        <td class="pa-0">
          <div class="legend-color-blue"></div>
        </td>
        <td><span>{{ $t('LIST_DIVERSE.FORMS_SENT_TO_REGISTER') }}</span></td>
      </tr>
      <tr>
        <td class="pa-0">
          <div class="legend-color-grey"></div>
        </td>
        <td><span>{{ $t('LIST_DIVERSE.FORMS_IGNORED_FOR_REPORT') }}</span></td>
      </tr>
      </tbody>
    </table>

    <div class="layout-column" v-if="legendKey==='systemicTherapy' || legendKey==='radiationTherapy'">
      <span v-if="legendKey==='systemicTherapy'" class="mb-1">{{ $t('LIST_DIVERSE.HEADER_SYMBOLS_SYSTEMIC_THERAPIES') }}:</span>
      <span v-if="legendKey==='radiationTherapy'" class="mb-1">{{ $t('LIST_DIVERSE.HEADER_SYMBOLS_RADIATION_THERAPIES') }}:</span>
      <div class="layout-row"><v-icon small color="white">mdi-checkbox-blank-circle-outline</v-icon><span class="ml-3">{{ $t('LIST_DIVERSE.START_THERAPY_FORM_NOT_LINKED') }}</span></div>
      <div class="layout-row"><v-icon small color="white">mdi-checkbox-marked-circle-outline</v-icon><span class="ml-3">{{ $t('LIST_DIVERSE.START_THERAPY_FORM_LINKED') }}</span></div>
      <div class="layout-row"><v-icon small color="white">mdi-checkbox-blank-circle</v-icon><span class="ml-3">{{ $t('LIST_DIVERSE.END_THERAPY_FORM') }}</span></div>
    </div>

    <div class="layout-column" v-if="legendKey==='patientList'">
      <span class="mb-1">{{ $t('LIST_DIVERSE.HEADER_SYMBOLS_PATIENT_LIST') }}:</span>
      <div class="layout-row"><v-icon small color="white">mdi-ghost</v-icon><span class="ml-3">{{ $t('LIST_DIVERSE.IGNORED_PATIENTS') }}</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "legendTable",
  props: {
    legendKey: {
      type: String
    }
  }
}
</script>

